
import Swiper from 'vux/src/components/swiper/swiper.vue'

import { mapGetters } from 'vuex';
import List from '@/components/Hall/List';
import DigitalCapacity from '@/components/Hall/DigitalCapacity';
import Vlogin from '../../components/popUp';
import api from '../../api'


const bannerImg = require('@/assets/images/Jiesuan-banner.jpg');

export default {
components: { Swiper, List, DigitalCapacity, Vlogin },
data: () => ({
bannerDatas: [
{ url: '', img: require('@/assets/images/banner1.png') },




],
tenderList: [],
bulletin: [],
promotion: [],
oldUrl: '',
bulletinUrl: '',
}),
mounted() {
if (window.location.href.indexOf('chinawayltd') !== -1) {
this.oldUrl = 'http://test.tender.g7s.chinawayltd.com/mobile/index.html#!/notice/list?utm_campaign=2018-06-26&utm_source=mobile';
this.bulletinUrl = 'http://test.tender.g7s.chinawayltd.com/mobile/index.html#!/market/list?utm_source=mobile';
} else {
this.bulletinUrl = 'https://e-bidding.g7s.huoyunren.com/mobile/index.html#!/market/list?utm_campaign=2019-01-25&utm_source=mobile';
this.oldUrl = 'https://e-bidding.g7s.huoyunren.com/mobile/index.html#!/notice/list?utm_source=mobile';
}
if (this.isUpper && this.isLogin) {
this.$vux.toast.text('您不是车队, 不能访问此页面');
this.$router.push({
name: 'mineIndex',
})
}
this.getHotList();

this.getBulletin();
},
computed: {
...mapGetters([
'isLower',
'isUpper',
]),
isLogin() {
return this.$store.state.isLogin;
},
},
methods: {
getPromotion () {
api.vega.tender.promotion().then((res) => {
const data = res.data.data;
this.promotion = data;
})
},
getBulletin () {
api.vega.tender.bulletin().then((res) => {
const data = res.data.data;
this.bulletin = data;
})
},
toOldBulletin (item) {

if (window.location.href.indexOf('chinawayltd') !== -1) {
window.location.href = `http://test.tender.g7s.chinawayltd.com/mobile/index.html#!/market/${item.id}?utm_campaign=2018-07-05&utm_source=mobile`;
} else {
window.location.href = `https://e-bidding.g7s.huoyunren.com/mobile/index.html#!/market/${item.id}?utm_campaign=2019-01-25&utm_source=mobile`;
}
},
toOldSystem (item) {

if (window.location.href.indexOf('chinawayltd') !== -1) {
window.location.href = `http://test.tender.g7s.chinawayltd.com/mobile/index.html#!/notice/${item.id}?utm_campaign=2018-06-26&utm_source=mobile`;
} else {
window.location.href = `https://e-bidding.g7s.huoyunren.com/mobile/index.html#!/notice/${item.id}?utm_campaign=2019-01-25&utm_source=mobile`
}
},
toDetail(item) {
this.$router.push({
path: '/hall/detail',
query: {
id: item.id,
},
});
},
getHotList() {
api.vega.tender.getHot().then((res) => {
const data = res.data.data;
this.tenderList = data;
})
},
gotoNormalTender() {
this.$router.push({
path: '/hall/normalTender',
});
},
},
};
